import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"

export const TransferFlowFormItemFragment = graphql(
  `
    fragment TransferFlowFormItem_item on Item {
      id
      tokenId
      name
      imageUrl
      standard
      collection {
        ...CollectionLockup
      }
      ownership(address: $address) {
        quantity
      }
    }
  `,
  [CollectionLockupFragment],
)
